export const AUTH_TOKEN_KEY = 'authToken';

export function getAuthToken() {
  try {
    const token = window.localStorage.getItem(AUTH_TOKEN_KEY);
    return token && token !== 'undefined' ? token : null;
  } catch (_) {
    return null;
  }
}

export function persistAuthToken(authToken) {
  if (typeof authToken !== 'string' || !authToken.trim()) {
    return false;
  }

  try {
    window.localStorage.setItem(AUTH_TOKEN_KEY, authToken.trim());
    return true;
  } catch (_) {
    return false;
  }
}

export function clearAuthToken() {
  try {
    window.localStorage.removeItem(AUTH_TOKEN_KEY);
  } catch (_) {
    // Storage may be unavailable in privacy-restricted browser contexts.
  }
}
